// Author panyurou
// Date 2023-03-07 15:10:36

class SithMesStoolExternalInspection {
constructor({
        id = null,
        ids = '',
        inspector = '',
        inspectionReportIds = '',
        inspectionStatus = '',
        planInspectionTime = '',
        poId = '',
        remark = '',
        inspectionReports = ''}
= {}) {
    this.id = id;
    this.ids = ids;
    this.inspector = inspector;
    this.inspectionReportIds = inspectionReportIds;
    this.inspectionStatus = inspectionStatus;
    this.planInspectionTime = planInspectionTime;
    this.poId = poId;
    this.remark = remark;
    this.inspectionReports = inspectionReports;
}
}

function newEntity() {
return new SithMesStoolExternalInspection();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'purchasingDocNumber',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.purchasingDocNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'purchasingDocItemNumber',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.purchasingDocItemNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'wbsElement',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.wbsElement',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'machine1',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.machine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'pmName',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.pmName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'engCoreCompressorName',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.engCoreCompressorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'creatorName',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.creatorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'vendorAccountNumber',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.vendorAccountNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'vendorNameEn',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.vendorNameEn',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'vendorNameZh',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.vendorNameZh',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'accountAssignmentCategory',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.accountAssignmentCategory',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
            linkTo: 'material_bom',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialShortText',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.materialShortText',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'purchaseOrderQuantity',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.purchaseOrderQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'purchaseOrderUnit',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.purchaseOrderUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'itemCreateDate',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.itemCreateDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionPoint',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.inspectionPoint',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'extInspectionRequestAttachments',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.extInspectionRequestAttachments',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectorName',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.inspectorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'planInspectionTime',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.planInspectionTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionStatus',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.inspectionStatus',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '0', text: '未检验' },
                            { value: '1', text: '检验合格' },
                            { value: '2', text: '检验不合格' },
                            { value: '3', text: '放弃检验' }
            ]
        }
        },
        {
        key: 'inspectionReports',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.inspectionReports',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'lastModifiedInspectionStatusTime',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.lastModifiedInspectionStatusTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'lastModifiedInspectorTime',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.lastModifiedInspectorTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolExternalInspection.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    purchasingDocNumberFilter : '',
    purchasingDocItemNumberFilter : '',
    projectCodeFilter : '',
    wbsElementFilter : '',
    machine1Filter : '',
    pmFilter : '',
    pmNameFilter : '',
    engCoreCompressorFilter : '',
    engCoreCompressorNameFilter : '',
    creatorNameFilter : '',
    vendorAccountNumberFilter : '',
    vendorNameZhFilter : '',
    vendorNameEnFilter : '',
    accountAssignmentCategoryFilter : '',
    itemCreateDateFilter : '',
    materialNumberFilter : '',
    materialShortTextFilter : '',
    purchaseOrderQuantityFilter : '',
    purchaseOrderUnitFilter : '',
    inspectorFilter : '',
    inspectionStatusFilter : '',
    planInspectionTimeRteFilter : '',
    planInspectionTimeLteFilter : '',
    lastModifiedInspectionStatusTimeRteFilter : '',
    lastModifiedInspectionStatusTimeLteFilter : '',
    lastModifiedInspectorTimeRteFilter : '',
    lastModifiedInspectorTimeLteFilter : '',
    poIdFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'purchasingDocNumberFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.purchasingDocNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'purchasingDocItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.purchasingDocItemNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsElementFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.wbsElement',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'machine1Filter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.machine1',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'pmNameFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.pmName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'engCoreCompressorNameFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.engCoreCompressorName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'creatorNameFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.creatorName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'vendorAccountNumberFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.vendorAccountNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'vendorNameZhFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.vendorNameZh',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'vendorNameEnFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.vendorNameEn',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'accountAssignmentCategoryFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.accountAssignmentCategory',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemCreateDateFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.itemCreateDate',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialNumberFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.materialNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialShortTextFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.materialShortText',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'purchaseOrderQuantityFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.purchaseOrderQuantity',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'purchaseOrderUnitFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.purchaseOrderUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectorFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.inspector',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionStatusFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.inspectionStatus',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '未检验' },
                { value: '1', text: '检验合格' },
                { value: '2', text: '检验不合格' },
                { value: '3', text: '放弃检验' }
            ]
        }
        },
        {
        key: 'planInspectionTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.planInspectionTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'planInspectionTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.planInspectionTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastModifiedInspectionStatusTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.lastModifiedInspectionStatusTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastModifiedInspectionStatusTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.lastModifiedInspectionStatusTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastModifiedInspectorTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.lastModifiedInspectorTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastModifiedInspectorTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolExternalInspection.filter.lastModifiedInspectorTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'inspector',
        label: 'label.sith.stool.sithMesStoolExternalInspection.entity.inspector',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionStatus',
        label: 'label.sith.stool.sithMesStoolExternalInspection.entity.inspectionStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'planInspectionTime',
        label: 'label.sith.stool.sithMesStoolExternalInspection.entity.planInspectionTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolExternalInspection.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionReports',
        label: 'label.sith.stool.sithMesStoolExternalInspection.entity.inspectionReportIds',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'inspectionReportIds'
                }
        }
]

export {SithMesStoolExternalInspection, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
